import store from '@/store'
import { Message } from 'view-design'

/**
 * 检查是否有权限
 * @param {*} id
 */
export function checkBtnPermission(id) {
    if (id && id.length > 0) {
        const roles = store.getters['menu/getBUTTONS']
        const permissionRoles = id
        if (roles.indexOf(permissionRoles) > -1) {
            return true
        }
        return false
    } else {
        return false
    }
}


// 获取多少天后日期 获取多少天前日期
export function formatDate(num) {
    var now = new Date()
    var nowTime = now.getTime()
    var oneDayTime = 24 * 60 * 60 * 1000
    var ShowTime = nowTime + num * oneDayTime
    var myDate = new Date(ShowTime)
    var y = myDate.getFullYear() // 年
    var m = myDate.getMonth() + 1 // 月
    var d = myDate.getDate() // 日
    return formatDateYMD([y, m, d].map(padStartConvert).join('-'))
}

export function padStartConvert(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
}

export function formatDateYMD(date, format) {
    if (!date) return
    if (!format) format = 'yyyy-MM-dd'
    switch (typeof date) {
        case 'string':
            date = new Date(date.replace(/-/, '/'))
            break
        case 'number':
            date = new Date(date)
            break
    }
    if (!(date instanceof Date)) return
    var dict = {
        'yyyy': date.getFullYear(),
        'M': date.getMonth() + 1,
        'd': date.getDate(),
        'H': date.getHours(),
        'm': date.getMinutes(),
        's': date.getSeconds(),
        'MM': ('' + (date.getMonth() + 101)).substr(1),
        'dd': ('' + (date.getDate() + 100)).substr(1),
        'HH': ('' + (date.getHours() + 100)).substr(1),
        'mm': ('' + (date.getMinutes() + 100)).substr(1),
        'ss': ('' + (date.getSeconds() + 100)).substr(1)
    }
    return format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function() {
        return dict[arguments[0]]
    })
}


export function formatDateToStartOfDay(dateStr) {
  if (!dateStr) return dateStr
  if (dateStr && dateStr.indexOf('00:00:00') > -1) return dateStr
  return dateStr + ' 00:00:00'
}

export function formatDateToEndOfDay(dateStr) {
  if (!dateStr) return dateStr
  if (dateStr && dateStr.indexOf('23:59:59') > -1) return dateStr
  return dateStr + ' 23:59:59'
}

export function validateAndFormatTime(startTime, endTime) {
  if (startTime && endTime) {
    if (startTime > endTime) {
      return {
        msg: '开始时间需要早于结束时间'
      }
    } else {
      return {
        startTime: formatDateToStartOfDay(startTime),
        endTime: formatDateToEndOfDay(endTime),
        msg: ''
      }
    }
  } else {
    return {
      startTime:
        startTime && startTime.length ? formatDateToStartOfDay(startTime) : '',
      endTime: endTime && endTime.length ? formatDateToEndOfDay(endTime) : '',
      msg: ''
    }
  }
}

export function formatTimeParams(startKey, endKey, form) {
  let params = JSON.parse(JSON.stringify(form))
  let data = validateAndFormatTime(params[startKey], params[endKey])
  if (data.msg.length) {
    Message.error({
      content: data.msg,
      duration: 5
    })
    delete params[startKey]
    delete params[endKey]
    form[startKey] = ''
    form[endKey] = ''
  } else {
    params[startKey] = data.startTime
    params[endKey] = data.endTime
  }
  return params
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function() {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function(...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

export function notify() {
    Message.info({
        content: '正在开发中。。。。。。敬请期待！',
        duration: 2
    })
}

export function jsToFormData(config) {
    const formData = new FormData()
    Object.keys(config).forEach(key => {
        formData.append(key, config[key])
    })
    return formData
}

export function encodeUTF8(s) {
    var i,
        r = [],
        c,
        x
    for (i = 0; i < s.length; i++)
        if ((c = s.charCodeAt(i)) < 0x80) r.push(c)
    else if (c < 0x800) r.push(0xc0 + ((c >> 6) & 0x1f), 0x80 + (c & 0x3f))
    else {
        if ((x = c ^ 0xd800) >> 10 == 0)
            //对四字节UTF-16转换为Unicode
            (c = (x << 10) + (s.charCodeAt(++i) ^ 0xdc00) + 0x10000), r.push(0xf0 + ((c >> 18) & 0x7), 0x80 + ((c >> 12) & 0x3f))
        else r.push(0xe0 + ((c >> 12) & 0xf))
        r.push(0x80 + ((c >> 6) & 0x3f), 0x80 + (c & 0x3f))
    }
    return r
}

export function sha1(s) {
    var data = new Uint8Array(encodeUTF8(s))
    var i, j, t
    var l = (((data.length + 8) >>> 6) << 4) + 16,
        s = new Uint8Array(l << 2)
    s.set(new Uint8Array(data.buffer)), (s = new Uint32Array(s.buffer))
    for (t = new DataView(s.buffer), i = 0; i < l; i++) s[i] = t.getUint32(i << 2)
    s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8)
    s[l - 1] = data.length << 3
    var w = [],
        f = [
            function() {
                return (m[1] & m[2]) | (~m[1] & m[3])
            },
            function() {
                return m[1] ^ m[2] ^ m[3]
            },
            function() {
                return (m[1] & m[2]) | (m[1] & m[3]) | (m[2] & m[3])
            },
            function() {
                return m[1] ^ m[2] ^ m[3]
            },
        ],
        rol = function(n, c) {
            return (n << c) | (n >>> (32 - c))
        },
        k = [1518500249, 1859775393, -1894007588, -899497514],
        m = [1732584193, -271733879, null, null, -1009589776];
    (m[2] = ~m[0]), (m[3] = ~m[1])
    for (i = 0; i < s.length; i += 16) {
        var o = m.slice(0)
        for (j = 0; j < 80; j++)(w[j] = j < 16 ? s[i + j] : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1)), (t = (rol(m[0], 5) + f[(j / 20) | 0]() + m[4] + w[j] + k[(j / 20) | 0]) | 0), (m[1] = rol(m[1], 30)), m.pop(), m.unshift(t)
        for (j = 0; j < 5; j++) m[j] = (m[j] + o[j]) | 0
    }
    t = new DataView(new Uint32Array(m).buffer)
    for (var i = 0; i < 5; i++) m[i] = t.getUint32(i << 2)

    var hex = Array.prototype.map
        .call(new Uint8Array(new Uint32Array(m).buffer), function(e) {
            return (e < 16 ? '0' : '') + e.toString(16)
        })
        .join('')
    return hex
}

export function handleRoute(route, top) {
    if (route.children) {
        route.children = route.children.filter((item) => {
            return item.type != 'button'
        })
    }
    route.type = top ? 'menu' : route.type
    let asyncModule = { 'meta': {} }
    asyncModule['path'] = `/${route.functionId}`
    asyncModule['name'] = `${route.functionId}Page`
    asyncModule['meta'] = {}
    asyncModule.meta['name'] = route.functionName
    asyncModule.meta['icon'] = route.functionIcon

    switch (route.type) {
        case 'menu':
            let array = []
            if (top && (route.children && route.children.length == 0) || !route.children) {
                let subAsyncModule = { 'meta': {} }
                subAsyncModule['path'] = `/${route.functionId}`
                subAsyncModule['name'] = `${route.functionId}Page`
                subAsyncModule['meta'] = {}
                subAsyncModule.meta['name'] = route.functionName
                subAsyncModule.meta['icon'] = route.functionIcon
                if (route.path) {
                    const component = resolve => require([`@/views/${route.path}`], resolve)
                    subAsyncModule['component'] = component
                    array.push(subAsyncModule)
                }
                asyncModule.single = true

            } else {
                if (route.children) {
                    route.children.forEach((subRoute) => {
                        if (subRoute.type == 'page' || (subRoute.type == 'menu' && subRoute.children && subRoute.children.length))
                            array.push(handleRoute(subRoute))
                    })
                    asyncModule.component = { render(d) { return d('router-view') } }
                }
            }
            asyncModule.children = array
            break
        case 'page':
            const component = resolve => require([`@/views/${route.path}`], resolve)
            asyncModule['component'] = component
            break

    }
    asyncModule.type = route.type
    return asyncModule
}


export function handleButtton(routes, array) {
    routes.forEach((route) => {
        // console.log(route.functionName)
        if (route.children && route.children.length) {
            handleButtton(route.children, array)
        } else {
            if (route.type == 'button')
                array.push(route)
        }
    })
}


export function updateStripe(source) {
    let array = []
    source.forEach((item, idx) => {
        if (idx == 0) {
            array.push(item)
            if (item.expand && item.subs && item.subs.length) {
                array.push({
                    type: "header"
                })
                array = array.concat(item.subs)
            }
        } else {
            if (item.expand && item.subs && item.subs.length) {
                array.push(item)
                array.push({
                    type: "header"
                })
                array = array.concat(item.subs)
            } else {
                array.push(item)
            }
        }
    })

    array.forEach((item, idx) => {
        // item.stripe = idx % 2 == 1
        item.stripe = false
    })
}

export function getPlatform() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag ? 'mobile' : 'pc'
}


export function getCommandStatus(status) {
    let statusVal = '未配置'
    switch (parseInt(status)) {
        case 0:
            statusVal = '未配置'
            break
        case 1:
            statusVal = '已下发'
            break
        case 2:
            statusVal = '下发成功'
            break
    }
    return statusVal
}